import React, { ReactNode } from 'react';
import cx from 'classnames';
import { Text, Button, ButtonProps, IconButton, Icon } from '@intellecteu/common-ui';

import s from './styles.module.scss';

type TSidebarSizes = 's' | 'm' | 'l';

interface ISidebarCollapsed {
  overlayedItemId: string;
  overlayClassName?: string;
  className?: string;
  closeFunction?: () => void;
  title?: string | ReactNode;
  children?: ReactNode;
  submitButtonProps?: ButtonProps;
  customFooter?: ReactNode;
  size?: TSidebarSizes;
}

type TitleType = React.ReactElement<{ className: string }>;

export const SidebarCollapsed = ({
  overlayedItemId,
  overlayClassName,
  className,
  title,
  closeFunction,
  submitButtonProps,
  children,
  customFooter,
  size = 's',
}: ISidebarCollapsed) => {
  let titleContent = <div />;
  if (title) {
    titleContent =
      typeof title !== 'string' ? (
        React.cloneElement(title as TitleType, { className: s.headerInput })
      ) : (
        <Text size={Text.size.l} weight={Text.weight.bold} className={s.headerTitle}>
          {title}
        </Text>
      );
  }

  return (
    <div className={cx(s.overlay, overlayClassName)}>
      <div id={overlayedItemId} className={cx(s.sidebarCollapsed, s[`sidebarCollapsed__${size}`], className)}>
        <div className={s.header}>
          <IconButton
            showHover
            className={s.headerClose}
            onClick={closeFunction}
            iconSize="s"
            iconName={Icon.icons.denied}
          />
          {titleContent}
        </div>

        <div className={s.content}>{children}</div>

        <div className={s.footer}>
          {customFooter || (
            <>
              <Button variant="secondary" onClick={closeFunction}>
                Cancel
              </Button>

              {submitButtonProps ? <Button {...submitButtonProps} /> : null}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
